import { Button, Icon, TelegramAlert } from '@viaja/design-system';
import { firstName } from '@viaja/domain';
import { useState } from 'react';
import { useMe, useTelegram, useTestTelegram, useUnlinkTelegram } from '../../lib/queries';
import { Notice } from '../../ui/feedback';

/** Vínculo com o bot: prévia da mensagem (TelegramAlert) e botão para conectar. */
export function TelegramCard() {
  const me = useMe();
  const status = useTelegram();
  const unlink = useUnlinkTelegram();
  const test = useTestTelegram();
  const name = firstName(me.data?.name ?? 'Cris');
  const [checked, setChecked] = useState(false);

  if (status.isPending) return <p className="small app-meta">Verificando o Telegram…</p>;
  if (status.error) return <Notice>{status.error.message}</Notice>;
  const s = status.data;

  if (s.linked) {
    return (
      <div className="app-stack app-stack--tight">
        <p className="body">
          <Icon name="check" size={20} /> Conectado. Os alertas chegam no seu Telegram.
        </p>
        <div className="app-row">
          <Button variant="secondary" size="sm" disabled={test.isPending} onClick={() => test.mutate()}>
            {test.isPending ? 'Enviando…' : 'Enviar alerta de teste'}
          </Button>
          <Button variant="quiet" size="sm" disabled={unlink.isPending} onClick={() => unlink.mutate()}>
            Desconectar
          </Button>
        </div>
        {test.isSuccess ? <p className="small app-meta">Enviado. Confira o Telegram.</p> : null}
        {test.error ? <Notice>{test.error.message}</Notice> : null}
      </div>
    );
  }

  return (
    <div className="app-stack">
      <p className="body app-meta">É por lá que o aviso chega a tempo. A mensagem fica assim:</p>
      <TelegramAlert
        name={name}
        route="São Paulo → Lisboa · 21–28 mai 2027"
        price={3390}
        target={3400}
        detail="16% abaixo do típico para essa rota."
        time="07:02"
      />
      <p className="caption app-meta">Exemplo com valores fictícios.</p>
      {s.configured && s.linkUrl ? (
        <Button
          variant="secondary"
          icon="alerta"
          block
          onClick={() => window.open(s.linkUrl ?? '', '_blank', 'noopener')}
        >
          Conectar Telegram
        </Button>
      ) : (
        <Notice tone="neutral">O bot do Telegram ainda não foi configurado neste servidor.</Notice>
      )}
      {s.configured ? (
        <Button
          variant="quiet"
          size="sm"
          disabled={status.isFetching}
          onClick={() => status.refetch().then(() => setChecked(true))}
        >
          {status.isFetching ? 'Verificando…' : 'Já conectei'}
        </Button>
      ) : null}
      {checked && !status.isFetching ? (
        <Notice tone="neutral">
          Ainda não recebi o seu Iniciar. Toque em Conectar Telegram, depois em Iniciar no bot, e volte aqui.
        </Notice>
      ) : null}
    </div>
  );
}
